import React from 'react'
import { Box, TextField, makeStyles } from '@material-ui/core'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

import { VendorPerformancePreset } from './datePresets'

const PRESET_OPTIONS: { value: VendorPerformancePreset; label: string }[] = [
    { value: 'all_time', label: 'All time' },
    { value: 'last_12_months', label: 'Last 12 months' },
    { value: 'last_quarter', label: 'Last quarter' },
    { value: 'last_month', label: 'Last month' },
]

const useStyles = makeStyles((theme) => ({
    filters: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    presetToggle: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        '& .MuiToggleButton-root': {
            textTransform: 'none',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            fontWeight: 500,
            border: 'none',
            '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
        },
    },
    dateFields: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
    },
}))

interface Props {
    preset: VendorPerformancePreset | null
    startDate: string
    endDate: string
    onPresetChange: (preset: VendorPerformancePreset) => void
    onStartDateChange: (value: string) => void
    onEndDateChange: (value: string) => void
}

export const VendorPerformanceDateFilters = ({
    preset,
    startDate,
    endDate,
    onPresetChange,
    onStartDateChange,
    onEndDateChange,
}: Props) => {
    const classes = useStyles()

    return (
        <Box className={classes.filters}>
            <ToggleButtonGroup
                exclusive
                value={preset}
                onChange={(_event, value: VendorPerformancePreset | null) => {
                    if (value) {
                        onPresetChange(value)
                    }
                }}
                size="small"
                className={classes.presetToggle}
            >
                {PRESET_OPTIONS.map((option) => (
                    <ToggleButton key={option.value} value={option.value}>
                        {option.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>

            <Box className={classes.dateFields}>
                <TextField
                    label="Start"
                    type="date"
                    size="small"
                    variant="outlined"
                    value={startDate}
                    onChange={(event) => onStartDateChange(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label="End"
                    type="date"
                    size="small"
                    variant="outlined"
                    value={endDate}
                    onChange={(event) => onEndDateChange(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                />
            </Box>
        </Box>
    )
}
